import HostsIndex from './HostsIndex';
import HostsCreate from './HostsCreate';
import HostsSettings from './HostsSettings';
import HostsSingle from './HostsSingle';

export default function (app) {

    const settings = HostsSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 14,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Pending Verification",
                path: settings.path + "/status/pendingVerification",
                caps: settings.indexCaps
            },
            {
                label: "Verified",
                path: settings.path + "/status/verified",
                caps: settings.indexCaps
            },
            {
                label: "Rejected",
                path: settings.path + "/status/rejected",
                caps: settings.indexCaps
            },
            {
                label: "Revoked",
                path: settings.path + "/status/revoked",
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            }
        ],
    });

    HostsIndex(app, settings);

    HostsCreate(app, settings);

    HostsSingle(app, settings);

}